import types from "./types";

const defaultValues = {
  settingsOpen: false,
  debriefOpen: false,
  snackbarOptions: null,
};

export default function reducer(state = defaultValues, action) {
  switch (action.type) {
    case types.OPEN_SETTINGS: {
    return {
      ...state,
      settingsOpen: true,
    };
  }

  case types.CLOSE_SETTINGS: {
    return {
      ...state,
      settingsOpen: false,
    };
  }

  case types.OPEN_DEBRIEF: {
    return {
      ...state,
      debriefOpen: true
    };
  }

  case types.CLOSE_DEBRIEF: {
    return {
      ...state,
      debriefOpen: false
    };
  }

  case types.SET_SNACKBAR: {
    return {
      ...state,
      snackbarOptions: action.payload,
    };
  }

  default: {
    return state;
  }
  }
}



// WEBPACK FOOTER //
// ./src/redux/nav/reducers.js